import { quantityLimitSectionId } from 'Constants/Configuration'
import { retrieveSelectedArticleKey } from '../../Helpers/ArticlesHelper'
import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import store from '../../store'
import { retrieveArticleDetailData } from './ArticleServices'
import { prepareStores } from 'Helpers/StoreHelper'
import { handleQuantityLimitLoading } from 'Slices/Kiosk/ArticleDetailSlice'

//Quantity Limit belongs to omnichannel
const ReloadQuantityLimitAndDelays = (dispatch, getState) => {
  const state = getState()
  const rowKeys = state.present.article.rowKeysSelected
  const isEditTableDisable = state.present.tableOptions.editTableDisable
  const rowKey = rowKeys && rowKeys.length === 1 && isEditTableDisable ? rowKeys[0] : null

  if (state.present.configuration.isOmnichannelAndPricesVisibile || state.present.configuration.limitQtyModule) {
    retrieveArticleDetailData(rowKey, dispatch)
  }
}

const getQuantityLimitData = rowKey => {
  const dispatch = store.dispatch
  //avoiding user to change quantity limit data before data is fully loaded as it can cause bad ui behaviour
  dispatch(handleQuantityLimitLoading(true))

  var state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === quantityLimitSectionId) >= 0
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    !state.present.configuration.isOmnichannelAndPricesVisibile ||
    !state.present.configuration.limitQtyModule ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const body = {
    stores: prepareStores(state),
  }

  return createRequest(
    '/api/articles/' + rowKey + '/limits/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  ).then(response => {
    dispatch(handleQuantityLimitLoading(false))
    return response.json()
  })
}

const updateQuantityLimitAndDelays = (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    !state.present.configuration.isOmnichannelAndPricesVisibile ||
    !state.present.configuration.limitQtyModule ||
    !token
  ) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  const rowKeys = state.present.article.rowKeysSelected
  const articleEditTableDisable = state.present.tableOptions.editTableDisable
  const rowKey = articleEditTableDisable ? retrieveSelectedArticleKey(rowKeys) : null
  const body = state.present.articleDetail.articleSelected.quantityLimitData

  return createRequest(
    '/api/articles/' + rowKey + '/updateLimits/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  )
    .then(response => {
      retrieveArticleDetailData(rowKey, dispatch)
      return response
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed update quantity limits updateQuantityLimitAndDelays')
    })
}

export { getQuantityLimitData, updateQuantityLimitAndDelays, ReloadQuantityLimitAndDelays }
